import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import {MatInputModule,
		MatIconModule,
		MatCardModule,
		MatButtonModule,
		MatListModule,
		MatGridListModule,
		MatProgressBarModule,
		MatMenuModule,
		MatButtonToggleModule,
		MatToolbarModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ClientesRoutes } from './clientes.routing';
import { ClienteListaComponent } from './view-cliente/clientevista.component';
import { InfoclienteComponent } from './infocliente/infocliente.component';
@NgModule({
	imports: [
	CommonModule,
	FormsModule,
	ReactiveFormsModule,
	RouterModule.forChild(ClientesRoutes),
	MatIconModule,
	MatCardModule,
	MatButtonModule,
	ReactiveFormsModule,
	MatListModule,
	MatProgressBarModule,
	MatMenuModule,
	MatToolbarModule,
	FlexLayoutModule,
	MatInputModule,
	MatButtonToggleModule,
	MatGridListModule,
	NgxDatatableModule
],
declarations: [
	ClienteListaComponent,
	InfoclienteComponent
],
exports:[
	InfoclienteComponent,
]
})
export class ClientesModule {}
